import { createEvent, restore, sample } from 'effector'

import { fx } from 'src/libs'
import { Landing, LandingRequest, LandingResponse } from './types'

export const landingsListMounted = createEvent<LandingRequest>()

export const getLandings = fx<LandingRequest, LandingResponse>({
  method: 'GET',
  url: `/partner/material/landing_page`,
})

export const $landings = restore<Landing[]>(
  getLandings.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfLandings = restore(
  getLandings.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: landingsListMounted,
  fn: ({ limit, page }) => {
    let query = {
      limit,
      page,
    }

    return {
      query,
    }
  },
  target: getLandings,
})
